import React from 'react';
import { Box, Card, CardContent, Grid, Typography, Divider, Button } from '@mui/material';
import palette from 'src/theme/palette';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const RecentActivities = ({ recentActivity }) => {
  const activities = recentActivity?.data ?? [];
  
  const navigate = useNavigate();

  const handleRecentPage = () => navigate('/recent-activities');

  const formatDateWithMonth = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

  return (
    <Grid item xs={12} md={12}>
      <Card
        sx={{
          borderRadius: 1,
          boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
          transition: '0.3s',
          p: 1,
          height: '100%',
          backgroundColor: palette.primary.white,

          '&:hover': {
            boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
            transform: 'translateY(-4px)'
          }
        }}
      >
        <CardContent>
          {/* Header */}
          <Typography
            sx={{
              fontFamily: 'poppinsSemiBold',
              fontSize: 18,
              color: palette.primary.titledark,
              mb: 1
            }}
          >
            Recent Activities
          </Typography>

          {/* Table header */}
          <Box
            display="flex"
            justifyContent="space-between"
            sx={{
              pb: 1,
              borderBottom: `1px solid ${palette.primary.inputborder}`,

              color: palette.primary.title
            }}
          >
            <Typography sx={{ fontSize: 15, fontFamily: 'poppinsSemiBold' }}>Activity</Typography>
            <Typography sx={{ fontSize: 15, fontFamily: 'poppinsSemiBold' }}>Date</Typography>
          </Box>

          {/* Activity list */}
          {activities.map((item, index) => (
            <Box
              key={index}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                py: 2.28,
                borderBottom:
                  index !== activities.length - 1
                    ? `1px solid ${palette.primary.inputborder}`
                    : 'none'
              }}
            >
              <Typography
                sx={{
                  fontSize: 14,
                  color: palette.primary.title,
                  fontFamily: 'poppinsRegular'
                }}
              >
                {item?.reference_name}
              </Typography>
              <Typography
                sx={{
                  fontSize: 14,
                  color: palette.primary.title,
                  fontFamily: 'poppinsRegular'
                }}
              >
                  {formatDateWithMonth(item?.latest_date)}
              </Typography>
            </Box>
          ))}
          <Button
            variant="contained"
            onClick={handleRecentPage}
            sx={{
              background: palette.primary.main,
              color: palette.primary.contrastText,
              height: { xs: 48, sm: 40 },
              width: { xs: '100%', sm: 'full' },
              minWidth: { xs: '100%', sm: 'auto' },
              '&:hover': { background: palette.primary.dark },
              '&:disabled': { background: palette.grey[400] },
              fontSize: { xs: '14px', sm: '13px' }
            }}
          >
            View All Recent Activities
          </Button>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default RecentActivities;
